export default {
  whatsNew: {
    title: "Novedades — {version}",
    viewFullHistory: "Ver historial completo →",
    gotIt: "Entendido",
  },
};
